import { AD_QC_INIT_CAMPAIGN_TOTAL, AD_QC_UPDATE_TOTAL } from '../constants/ActionTypes';

export function initCampaignTotalAds(campaigns) {
  return { type: AD_QC_INIT_CAMPAIGN_TOTAL, campaigns };
}

export function updateTotalQCAds(campaigns, generalQCProgress) {
  return { type: AD_QC_UPDATE_TOTAL, campaigns, generalQCProgress };
}



// WEBPACK FOOTER //
// ./src/actions/AdQCActions.js